export default "__VITE_ASSET__85f02e12__"